import { useMutation } from "@tanstack/react-query";

import { useGetTransportAxiosInstance } from "@/constants";

export const useSendError = () => {
    const axiosInstance = useGetTransportAxiosInstance();

    return useMutation<boolean, Error, (string | object | undefined)[]>({
        mutationFn: (data) =>
            axiosInstance
                .post(`/notifications/error`, {
                    ...data,
                })
                .then((res) => res.data),
    });
};
